/**
 * Serializa um objeto de parâmetros em `URLSearchParams` repetindo a chave
 * com `[]` para arrays (`areas[]=a&areas[]=b`).
 *
 * `URLSearchParams`/`ky` transformam arrays com `String(array)` (vírgula) e o
 * backend PHP só monta `$_GET` como array quando a chave repete com `[]`.
 * `undefined`/`null` são omitidos.
 */
export function buildSearchParams(
  params: Record<string, unknown> | undefined
): URLSearchParams {
  const searchParams = new URLSearchParams()
  for (const [key, value] of Object.entries(params ?? {})) {
    appendSearchParam(searchParams, key, value)
  }
  return searchParams
}

function appendSearchParam(
  searchParams: URLSearchParams,
  key: string,
  value: unknown
) {
  if (value === undefined || value === null) {
    return
  }
  if (Array.isArray(value)) {
    const arrayKey = key.endsWith('[]') ? key : `${key}[]`
    for (const item of value) {
      appendSearchParam(searchParams, arrayKey, item)
    }
    return
  }
  searchParams.append(key, String(value))
}
